import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import SectionTitle from '@/components/atoms/fonts/SectionTitle';
import useSnackbar from '@/hooks/useSnackbar';
import LoadingComponent from '@components/templates/LoadingComponent';
import Meta from '@components/templates/Seo/Meta';

import { VisitsAbsencesTable } from './components/VisitsAbsencesTable';

import { Div, DivSearch, Header, SearchBox, TextFildStyled, DivNumProperty, DivAlert } from './styles';
import useVisitAbsencesService from '@/services/visits-absences';

const VisitAbsences = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { getAllPendingVisitAbsences, getAllAbsenceReasons } = useVisitAbsencesService();
    const [absenceReasons, setAbsenceReasons] = useState([]);
    const navigate = useNavigate();
    const snackbar = useSnackbar();
    const selectRef = useRef();
    const consultantId = sessionStorage.getItem('consultant_id') ?? null;
    const currentUserRole = Number(sessionStorage.getItem('currentUserRole') ?? 0);
    const { user, currentSegment: segment } = useSelector((state) => state.auth);
    const setBlur = () => {};
    const defaultOrder = segment == 2 ? true : false;
    const dispatch = useDispatch();

    const getAbsenceReasons = async () => {
        const resp = await getAllAbsenceReasons();
        setAbsenceReasons(resp);
        setIsLoading(false);
    };

    useEffect(() => {
        getAbsenceReasons();
    }, []);

    return (
        <>
            <Meta title="Justificativas" />

            {/* <ButtonBack /> */}

            {/* <Header>
                <SectionTitle tituloString={'Visitas não Realizadas'} marginHorizontal="0" />
            </Header> */}
            <Grid container spacing={2} sx={{ marginTop: '1rem', marginBottom: '2rem' }}>
                {!isLoading ? (
                    <VisitsAbsencesTable absenceReasons={absenceReasons} onDataChange={(item) => console.log(item)} />
                ) : (
                    <LoadingComponent />
                )}
            </Grid>
        </>
    );
};

export default VisitAbsences;
